import { Navigate, useParams, useSearch } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useTRPC } from '../../lib/trpc';
import { PageRoot, PageHeader } from '../ui/Page';
import { BackCrumb } from '../ui/Detail';
import {
  GoneState,
  StaleNotice,
  UnresolvedState,
  isNotFound,
  refreshFailed,
  shownState,
} from '../ui/QueryStates';
import { IconJobs } from '../icons';
import { JobWorkspace } from '../jobs/JobWorkspace';

/** Old execution UUIDs and new commercial UUIDs share historic links, never semantics. */
export function JobDetailPage() {
  const { jobId } = useParams({ from: '/office/jobs/$jobId' });
  const search = useSearch({ from: '/office/jobs/$jobId' });
  const trpc = useTRPC();
  const q = useQuery(trpc.commercialJob.resolveLink.queryOptions({ id: jobId }));
  const state = shownState(q, q.data);
  if (q.isError && isNotFound(q.error))
    return (
      <PageRoot>
        <BackCrumb to="/jobs" label="Jobs" />
        <GoneState icon={IconJobs} what="job" backTo="/jobs" backLabel="Back to jobs" />
      </PageRoot>
    );
  if (state !== 'ready')
    return (
      <PageRoot>
        <PageHeader title="Job" />
        <UnresolvedState
          state={state}
          icon={IconJobs}
          what="this job"
          error={q.error}
          onRetry={() => void q.refetch()}
        />
      </PageRoot>
    );
  if (q.data?.kind === 'work_order')
    return (
      <Navigate
        to="/work-orders/$workOrderId"
        params={{ workOrderId: q.data.id }}
        search={search}
        replace
      />
    );
  return (
    <>
      <StaleNotice show={refreshFailed(q, q.data)} onRetry={() => void q.refetch()} />
      {q.data?.kind === 'commercial_job' ? (
        <JobWorkspace commercialJobId={q.data.id} />
      ) : null}
    </>
  );
}
